import useFeatureFlags from 'hooks/useFeatureFlags';

function FeatureFlag({ flag, render, children }) {
  const featureFlagContainer = useFeatureFlags();
  const enabled = featureFlagContainer.enabled(flag);
  if (render && typeof render === 'function') {
    return render({ enabled });
  }

  if (enabled) {
    return children;
  }

  return null;
}

export default FeatureFlag;
